var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 483.2 483.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3AC2F2",
    d: "M161.6,129.6V84.8c0,-46.4 -29.6,-64.8 -64,-64.8s-64,19.2 -64,64.8v44.8",
    id: "path_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009CC6",
    d: "M98.4,20c34.4,0 63.2,19.2 63.2,64.8v44.8h-64",
    id: "path_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC114",
    d: "M169.6,201.6v-52c0,-52 -33.6,-73.6 -72,-73.6s-72,21.6 -72,73.6v52",
    id: "path_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA12A",
    d: "M98.4,76c38.4,0 71.2,21.6 71.2,73.6v52h-72",
    id: "path_3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3AC2F2",
    d: "M193.6,369.6V280c0,-84 -42.4,-118.4 -96,-118.4S1.6,196 1.6,280v81.6",
    id: "path_4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#009CC6",
    d: "M193.6,369.6V280c0,-84 -41.6,-118.4 -96.8,-118.4",
    id: "path_5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M97.6,365.6m-97.6,0a97.6,97.6 0,1 1,195.2 0a97.6,97.6 0,1 1,-195.2 0",
    id: "path_6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M97.6,268c53.6,0 97.6,44 97.6,97.6s-44,97.6 -97.6,97.6",
    id: "path_7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F423F",
    d: "M97.6,365.6m-64.8,0a64.8,64.8 0,1 1,129.6 0a64.8,64.8 0,1 1,-129.6 0",
    id: "path_8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#009CC6",
    d: "M97.6,365.6m-39.2,0a39.2,39.2 0,1 1,78.4 0a39.2,39.2 0,1 1,-78.4 0",
    id: "path_9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#007E9B",
    d: "M97.6,326.4c21.6,0 39.2,17.6 39.2,39.2s-17.6,39.2 -39.2,39.2",
    id: "path_10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M73.6,344m-22.4,0a22.4,22.4 0,1 1,44.8 0a22.4,22.4 0,1 1,-44.8 0",
    id: "path_11"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M123.2,396m-12,0a12,12 0,1 1,24 0a12,12 0,1 1,-24 0",
    id: "path_12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA12A",
    d: "M124.8,97.6H78.4L68,104.8l12,8.8h44.8c4,0 7.2,-2.4 7.2,-8C132,100 128.8,97.6 124.8,97.6z",
    id: "path_13"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA12A",
    d: "M124.8,113.6H78.4L68,124.8l12,12.8h44.8c4,0 7.2,-6.4 7.2,-12S128.8,113.6 124.8,113.6z",
    id: "path_14"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M121.6,123.2c0,3.2 -3.2,6.4 -6.4,6.4H72c-3.2,0 -6.4,-3.2 -6.4,-6.4V120c0,-3.2 3.2,-6.4 6.4,-6.4h43.2c3.2,0 6.4,3.2 6.4,6.4V123.2z",
    id: "path_15"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M121.6,99.2c0,3.2 -3.2,6.4 -6.4,6.4H72c-3.2,0 -6.4,-3.2 -6.4,-6.4V96c0,-3.2 3.2,-6.4 6.4,-6.4h43.2c3.2,0 6.4,3.2 6.4,6.4V99.2z",
    id: "path_16"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA12A",
    d: "M124.8,137.6H78.4L68,148.8l12,12.8h44.8c4,0 7.2,-6.4 7.2,-12S128.8,137.6 124.8,137.6z",
    id: "path_17"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M121.6,147.2c0,3.2 -3.2,6.4 -6.4,6.4H72c-3.2,0 -6.4,-3.2 -6.4,-6.4V144c0,-3.2 3.2,-6.4 6.4,-6.4h43.2c3.2,0 6.4,3.2 6.4,6.4V147.2z",
    id: "path_18"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#3AC2F2",
    d: "M449.6,129.6V84.8c0,-46.4 -29.6,-64.8 -64,-64.8s-64,19.2 -64,64.8v44.8",
    id: "path_19"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#009CC6",
    d: "M386.4,20c34.4,0 63.2,19.2 63.2,64.8v44.8h-64",
    id: "path_20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC114",
    d: "M457.6,201.6v-52c0,-52 -33.6,-73.6 -72,-73.6s-72,21.6 -72,73.6v52",
    id: "path_21"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA12A",
    d: "M386.4,76c38.4,0 71.2,21.6 71.2,73.6v52h-72",
    id: "path_22"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#3AC2F2",
    d: "M481.6,369.6V280c0,-84 -42.4,-118.4 -96,-118.4s-96,34.4 -96,118.4v81.6",
    id: "path_23"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#009CC6",
    d: "M481.6,369.6V280c0,-84 -40,-118.4 -96,-118.4v128",
    id: "path_24"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M385.6,365.6m-97.6,0a97.6,97.6 0,1 1,195.2 0a97.6,97.6 0,1 1,-195.2 0",
    id: "path_25"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M385.6,268c53.6,0 97.6,44 97.6,97.6s-44,97.6 -97.6,97.6",
    id: "path_26"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F423F",
    d: "M385.6,365.6m-64.8,0a64.8,64.8 0,1 1,129.6 0a64.8,64.8 0,1 1,-129.6 0",
    id: "path_27"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#009CC6",
    d: "M385.6,365.6m-39.2,0a39.2,39.2 0,1 1,78.4 0a39.2,39.2 0,1 1,-78.4 0",
    id: "path_28"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#007E9B",
    d: "M385.6,326.4c21.6,0 39.2,17.6 39.2,39.2s-17.6,39.2 -39.2,39.2",
    id: "path_29"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M362.4,344m-22.4,0a22.4,22.4 0,1 1,44.8 0a22.4,22.4 0,1 1,-44.8 0",
    id: "path_30"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M411.2,396m-12,0a12,12 0,1 1,24 0a12,12 0,1 1,-24 0",
    id: "path_31"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA12A",
    d: "M413.6,97.6h-46.4l-10.4,7.2l12,8.8h44.8c4,0 7.2,-2.4 7.2,-8C420.8,100 417.6,97.6 413.6,97.6z",
    id: "path_32"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA12A",
    d: "M413.6,113.6h-46.4l-10.4,11.2l12,12.8h44.8c4,0 7.2,-6.4 7.2,-12S417.6,113.6 413.6,113.6z",
    id: "path_33"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M409.6,123.2c0,3.2 -3.2,6.4 -6.4,6.4H360c-3.2,0 -6.4,-3.2 -6.4,-6.4V120c0,-3.2 3.2,-6.4 6.4,-6.4h43.2c3.2,0 6.4,3.2 6.4,6.4V123.2z",
    id: "path_34"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M409.6,99.2c0,3.2 -3.2,6.4 -6.4,6.4H360c-3.2,0 -6.4,-3.2 -6.4,-6.4V96c0,-3.2 3.2,-6.4 6.4,-6.4h43.2c3.2,0 6.4,3.2 6.4,6.4V99.2z",
    id: "path_35"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA12A",
    d: "M413.6,137.6h-46.4l-10.4,11.2l12,12.8h44.8c4,0 7.2,-6.4 7.2,-12S417.6,137.6 413.6,137.6z",
    id: "path_36"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M409.6,147.2c0,3.2 -3.2,6.4 -6.4,6.4H360c-3.2,0 -6.4,-3.2 -6.4,-6.4V144c0,-3.2 3.2,-6.4 6.4,-6.4h43.2c3.2,0 6.4,3.2 6.4,6.4V147.2z",
    id: "path_37"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#007E9B",
    d: "M288,278.4c0,-40.8 9.6,-68 25.6,-87.2v-41.6c0,-16 8,-28.8 8,-39.2l0,0c-8,-4 -22.4,-4.8 -35.2,-4.8h-89.6c-13.6,0 -27.2,0.8 -35.2,4.8l0,0c0,10.4 8,23.2 8,39.2v41.6c16,19.2 24.8,48 25.6,88l2.4,2.4h88.8L288,278.4L288,278.4z",
    id: "path_38"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#009CC6",
    d: "M195.2,279.2l2.4,2.4h88.8l1.6,-3.2l0,0c0,-40.8 9.6,-68 25.6,-87.2v-41.6c0,-16 8,-28.8 8,-39.2l0,0c-8,-4 -24.8,-4.8 -37.6,-4.8",
    id: "path_39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoData);
export default __webpack_public_path__ + "static/media/ic_no_data.013157d76fdca38f1ea20a13969a7d04.svg";
export { ForwardRef as ReactComponent };